/**
 * These are the file types that Crusher can convert between.
 */
export enum GeoSpatialFileType {
  ShapeFile = 'shapefile',
  GeoJSON = 'geojson',
  Gen3_2020 = '2020'
}
